import React from "react";
import { Button, Row, Table, Col } from "react-bootstrap";
import { Loader } from "./Loader";
import { BASE_URL } from "../store/constant";
import Axios from "axios";
import map from "lodash/map";
import get from "lodash/get";
import find from "lodash/find";
import _ from "lodash";
import { toast } from "react-toastify";
import styled from "styled-components";
import moment from "moment";
import $ from "jquery";
import { Input } from "./";
import { exportTableToExcel } from "../utils";
import CryptoJS from "crypto-js";
const uuidv4 = require("uuid");

const Wrapper = styled.div`
  position: relative;
  padding: 20px;
  width: 100%;
  border-radius: 10px;
  & h3 {
    text-align: center;
    display: none;
  }

  @media print {
    h3 {
      display: block;
    }
  }
`;

class LoginPopupRera extends React.Component {
  state = {
    isLoading: true,
    otpsend: "",
  };
  

  componentDidMount = async () => {
    this.setState({ isLoading: true }); //uniqueId
    console.log("this.props--->>>>>>>>", this.props);
   
    this.setState({
      uniqueId: get(this.props, "uniqueKey"),
      userName: get(this.props, "userName"),
      isLoading: false,
    });
  };

  render() {
    const { isLoading, otpsend, userName, uniqueId } = this.state;

    return (
      <Wrapper>
        {isLoading ? (
          <></>
        ) : (
          <div
            style={{ width: "100%" }}
            className="bg-c-white customTable"
            id="MonitoringofProgress"
          >
            <div style={{ width: "100%" }}>
              <Col md={12}>
                <>
                  <Row md={12} sm={12} xs={12}>
                    <p class="popup-text">
                      Please update the details of the Chairpersons / Members /
                      Secretaries of your Real Estate Regulatory Authority on
                      the Unified RERA Portal, if not already updated.
                    </p>
                  </Row>

                 <Row md={12} sm={12} xs={12} >
                  <Col md={6} sm={6} xs={6}>
                    <Button
                      size="sm"
                      className="mb-0 mt-4 w-100"
                      style={{ fontSize: 13, fontWeight: "Bolder", color: "white",background:"rgb(9 98 161)"  }}
                      onClick={() => this.props.onProfileClick()}
                    >
                      Update profile
                    </Button>
                  </Col>

                  <Col md={6} sm={6} xs={6}>
                    <Button
                      size="sm"
                      className="mb-0 mt-4 w-100"
                      style={{ fontSize: 13, fontWeight: "Bolder", color: "white", background:"rgb(9 98 161)" }}
                      onClick={() => this.props.onTrackerClick()}
                    >
                      Proceed for tracker
                    </Button>
                  </Col>

                </Row>
                </>
              </Col>
            </div>
          </div>
        )}
      </Wrapper>
    );
  }
}

export default LoginPopupRera;
